import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function SquarePlusIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M27 1C29.2091 1 31 2.79086 31 5V27C31 29.2091 29.2091 31 27 31H5C2.79086 31 1 29.2091 1 27V5C1 2.79086 2.79086 1 5 1H27ZM16 8.5C14.9645 8.5 14.125 9.33947 14.125 10.375V14.125H10.375C9.33947 14.125 8.5 14.9645 8.5 16C8.5 17.0355 9.33947 17.875 10.375 17.875H14.125V21.625C14.125 22.6605 14.9645 23.5 16 23.5C17.0355 23.5 17.875 22.6605 17.875 21.625V17.875H21.625C22.6605 17.875 23.5 17.0355 23.5 16C23.5 14.9645 22.6605 14.125 21.625 14.125H17.875V10.375C17.875 9.33947 17.0355 8.5 16 8.5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
